const SENSITIVE_QUERY_PARAMS = ['code', 'access_token', 'id_token', 'token', 'client_secret'];
const JWT_PATTERN = /[A-Za-z0-9_-]{20,}\.[A-Za-z0-9_-]{10,}\.[A-Za-z0-9_-]{10,}/g;
const LONG_BASE64_BLOB_PATTERN = /[A-Za-z0-9+/]{80,}={0,2}/g;
const MAX_ERROR_DETAIL_LENGTH = 500;
const MAX_URL_LENGTH = 500;

export function extractErrorMessageForLogging(error: unknown): string | undefined {
  if (typeof error === 'string') return error;
  if (!error || typeof error !== 'object') return undefined;

  const problemDetailsErrors = (error as { error?: { errors?: Record<string, unknown> } }).error?.errors;
  if (problemDetailsErrors && typeof problemDetailsErrors === 'object') {
    const keys = Object.keys(problemDetailsErrors);
    if (keys.length) return keys.join(',');
  }

  if ('message' in error && typeof (error as { message: unknown }).message === 'string') {
    return (error as { message: string }).message;
  }
  return undefined;
}

export function sanitizeErrorDetailForLogging(message: string | undefined): string | undefined {
  if (!message) return undefined;
  const redacted = message.replace(JWT_PATTERN, '[redacted-jwt]').replace(LONG_BASE64_BLOB_PATTERN, '[redacted-blob]');
  return redacted.length > MAX_ERROR_DETAIL_LENGTH ? redacted.slice(0, MAX_ERROR_DETAIL_LENGTH) : redacted;
}

export function sanitizeUrlForLogging(url: string): string {
  let result = url;
  try {
    const parsed = new URL(url);
    parsed.searchParams.forEach((_, key) => {
      if (SENSITIVE_QUERY_PARAMS.includes(key.toLowerCase())) {
        parsed.searchParams.set(key, '[redacted]');
      }
    });
    result = parsed.toString();
  } catch {
    result = url;
  }
  return result.length > MAX_URL_LENGTH ? result.slice(0, MAX_URL_LENGTH) : result;
}
